<template>
  <li class="product">
    <div class="product__data">
      <div class="product__image">
        <router-link :to="produtoPageLink" v-slot="{ href, route, navigate }">
          <button id="imgbutton" :href="href" @click="navigate">
            <img :src="url" alt="imagem produto" />
            {{ route.ProdutoPage }}
          </button>
        </router-link>
      </div>

      <div class="product__content">
        <div style="margin: 10px">
          <h3>{{ referencia }} - {{ nomeproduto }}</h3>
        </div>

        <div class="product__pricing">
          <div v-if="this.permissaoUsuarioPage">
            <div v-if="saldo != 999 && mostrarEstoque == 1" class="mb-3">
              <h4>Estoque: {{ saldo }}</h4>
            </div>
            <div>
              <h2>
                <strong>R$ {{ precoindividual }}</strong>
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div class="product__actions">
        <router-link
          class="btn btn--secondary"
          :to="produtoPageLink"
          v-slot="{ href, route, navigate }"
        >
          <button :href="href" @click="navigate">
            Ver Detalhes {{ route.ProdutoPage }}
          </button>
        </router-link>
        <button
          class="btn btn--primary"
          @click.stop="addToCart"
          :disabled="adding"
        >
          <span v-if="!adding">Adicionar ao Carrinho</span>
          <span v-else class="loading-container">
            <span class="spinner"></span>
            Carregando...
          </span>
        </button>
      </div>

      <v-snackbar v-model="snackbar" timeout="2000" color="success">
        Item adicionado ao carrinho!
      </v-snackbar>

      <v-snackbar v-model="snackbarError" timeout="3000" color="error">
        {{ errorMessage }}
      </v-snackbar>
    </div>
  </li>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["url", "nomeproduto", "referencia", "saldo", "codigo", "preco"],

  data() {
    return {
      snackbar: false,
      snackbarError: false,
      errorMessage: "",
      adding: false,
    };
  },
  computed: {
    ...mapState("empresa", ["permissaoUsuario"]),
    ...mapState("empresa", ["mostrarEstoque"]),
    ...mapState("login", ["dadosCliente"]),
    ...mapState("login", ["usuarioLogado"]),
    somaprecototal() {
      return (this.qtditem * this.preco).toLocaleString("pt-br", {
        minimumFractionDigits: 2,
      });
    },
    precoindividual() {
      if (this.preco !== null && this.preco !== undefined) {
        return this.preco.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
        });
      } else {
        return "0,00";
      }
    },

    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    produtoPageLink() {
      return "/" + this.tipo + "/" + this.loja + "/produtos/" + this.codigo;
    },
    permissaoUsuarioPage() {
      if (this.permissaoUsuario == "2") {
        return true;
      } else if (this.permissaoUsuario == "1" && this.usuarioLogado == true) {
        if (this.dadosCliente.aprovado == "S") {
          return true;
        }
        return false;
      } else return false;
    },
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
    carregarPermissaoUsuario() {
      this.$store.dispatch("empresa/permissaoUsuario");
    },
    carregarMostrarEstoque() {
      this.$store.dispatch("empresa/mostrarEstoque");
    },
    async addToCart() {
      if (!this.permissaoUsuarioPage || !this.preco) {
        return;
      }

      try {
        this.adding = true;

        // Check if the product has variations
        const enderecoLoja = this.$store.getters["loja/lojaSelecionada"];
        const response = await fetch(
          `https://apiciriuserp.com.br:2083/api/SKUCatalogo/Get?token=${enderecoLoja}&pProduto=${this.codigo}`
        );
        const responseData = await response.json();

        // Filter variations with stock > 0
        const variacoesDisponiveis = responseData.filter(
          (item) => parseFloat(item.saldo) > 0
        );

        // Check if there's no stock available
        if (variacoesDisponiveis.length === 0) {
          this.errorMessage = "Produto sem estoque disponível";
          this.snackbarError = true;
          return;
        }

        // If product has multiple variations, redirect to product page
        if (variacoesDisponiveis.length > 1) {
          this.$router.push(this.produtoPageLink);
          return;
        }

        // If product has only one variation, add directly to cart
        const produtoData = {
          nomeproduto: this.nomeproduto,
          codigo: this.codigo,
          url: this.url,
          preco: this.preco,
        };

        const selecao = [
          {
            codigo_sku: variacoesDisponiveis[0].codigo_sku,
            codigo_cor: variacoesDisponiveis[0].codigo_cor,
            qtd: 1,
            preco: this.preco,
            tamanho: variacoesDisponiveis[0].tamanho,
            descricao_sku: variacoesDisponiveis[0].descricao_sku,
            url: this.url,
            codigo_prod: this.codigo,
          },
        ];

        await this.$store.dispatch("carrinhos/produtosCalculados", {
          produtoSelecionado: selecao,
        });

        this.$store.commit("carrinhos/adicionarProdutoCarrinho", produtoData);
        this.snackbar = true;
      } catch (error) {
        console.error("Erro ao adicionar produto ao carrinho:", error);
        this.errorMessage = "Erro ao adicionar produto ao carrinho";
        this.snackbarError = true;
      } finally {
        this.adding = false;
      }
    },
  },
  created() {
    this.carregarPermissaoUsuario();
    this.carregarMostrarEstoque();
  },
};
</script>

<style scoped>
@import "@/styles/variables.css";

h4 {
  display: flex;
  flex-wrap: nowrap;
  font-weight: 350;
  font-size: 16px;
  margin: auto;
}

h2 {
  color: var(--primary-color);
  font-size: 1.3rem;
}

#marginzero {
  margin: 0px;
  display: inline;
}

#imgbutton {
  background-color: #31b19a00;
  border: none;
  padding: 0;
  margin: 0;
}

li {
  display: inline;
  margin: 0px;
}

.product__data {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
}

@media (max-width: 768px) {
  .product__data {
    width: auto;
    padding: 1rem;
    margin-bottom: 20px;
  }
}

@media (min-width: 769px) {
  .product__data {
    width: 18rem;
    padding: 1rem;
    margin: 2rem auto;
  }
}

.data__qtd {
  height: 0px;
  display: inherit;
  margin-top: 15px;
}

select {
  height: 40px;
  width: 60px;
  font-size: 20px;
}

p.quantity {
  font-size: 20px;
  margin-right: 5px;
}

.product__image {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;
  flex-shrink: 0;
  padding: 10px;
}

.product__image img {
  max-height: 90%;
  max-width: 90%;
  width: auto;
  height: auto;
  object-fit: contain;
}

@media (max-width: 768px) {
  .product__image {
    height: 200px;
  }
}

@media (min-width: 769px) {
  .product__image {
    height: 250px;
  }
}

.product__data h3 {
  margin: 0 0 0.5rem 0;
}

@media (max-width: 768px) {
  .product__data h3 {
    font-size: 1rem;
  }
}

@media (min-width: 769px) {
  .product__data h3 {
    font-size: 1.25rem;
  }
}

.product__data h4 {
  margin: 0;
  font-size: auto - 20%;
  display: contents;
}

.product__content {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  min-height: 120px;
}

.product__pricing {
  margin-top: auto;
  margin-bottom: 1rem;
}

.product__actions {
  text-align: center;
  margin: 0;
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0 1rem 1rem 1rem;
  flex-shrink: 0;
}

.product__actions .btn {
  font: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  border-radius: 10px;
  line-height: 1.1;
  font-weight: 600;
  letter-spacing: 0.2px;
  transition: background-color 160ms ease, color 160ms ease,
    box-shadow 160ms ease, transform 60ms ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid transparent;
}

.product__actions .btn:active {
  transform: translateY(1px);
}

.product__actions .btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.product__actions .btn .loading-container {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.product__actions .btn[loading="true"] {
  opacity: 0.7;
  pointer-events: none;
}

.product__actions .btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 177, 154, 0.25);
}

/* Primary button */
.product__actions .btn--primary {
  background-color: var(--primary-color);
  color: #ffffff;
  border-color: var(--primary-color);
}

.product__actions .btn--primary:hover {
  filter: brightness(0.98);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

/* Secondary (outline) button */
.product__actions .btn--secondary {
  background-color: #ffffff;
  color: var(--primary-color);
  border-color: var(--primary-color);
}

.product__actions .btn--secondary:hover {
  background-color: var(--primary-color);
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

@media (max-width: 768px) {
  .product__actions .btn {
    margin: 0;
    width: 100%;
  }
}

@media (min-width: 769px) {
  .product__actions .btn {
    margin: 0.5rem 0.25rem;
  }
}

.itens {
  font-size: 20px;
  text-align: center;
}

.itensdesc {
  font-size: 20px;
  font-weight: lighter;
  text-align: left;
}

.itensselec {
  padding: 40px;
  font-size: 20px;
  font-weight: lighter;
  text-align: center;
}

.itenstotal {
  font-size: 30px;
  color: black;
  text-align: left;
}
</style>
